/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoFromJSON, FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestToJSON, FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseFromJSON, FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestToJSON, FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseFromJSON, FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSON, FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSON, FxIdWebFeaturesGamesListResponseFromJSON, FxIdWebFeaturesGamesListWithConfigsResponseFromJSON, } from '../models/index';
/**
 *
 */
export class GamesApi extends runtime.BaseAPI {
    /**
     * **MUTATES:** `documentaccept`, `document`, `documentversion`    Accepts document version
     */
    async fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest', 'Required parameter "fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest" was null or undefined when calling fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/games/documents/accept`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestToJSON(requestParameters['fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * **MUTATES:** `documentaccept`, `document`, `documentversion`    Accepts document version
     */
    async fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentEndpoint(fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest, initOverrides) {
        await this.fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentEndpointRaw({ fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest: fxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest }, initOverrides);
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/games/documents/accepted`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsEndpoint(initOverrides) {
        const response = await this.fxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsEndpointRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest', 'Required parameter "fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest" was null or undefined when calling fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/games/documents/list-with-versions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestToJSON(requestParameters['fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsEndpoint(fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsEndpointRaw({ fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest: fxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetDocumentEndpointGetDocumentEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesDocumentsGetDocumentEndpointGetDocumentEndpoint().');
        }
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling fxIdWebFeaturesDocumentsGetDocumentEndpointGetDocumentEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/games/{Game}/documents/{Id}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))).replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetDocumentEndpointGetDocumentEndpoint(game, id, initOverrides) {
        const response = await this.fxIdWebFeaturesDocumentsGetDocumentEndpointGetDocumentEndpointRaw({ game: game, id: id }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest', 'Required parameter "fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest" was null or undefined when calling fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/games/documents/list-latest-unaccepted-documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSON(requestParameters['fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsEndpoint(fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsEndpointRaw({ fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest: fxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesGamesListEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/games/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesGamesListResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesGamesListEndpoint(initOverrides) {
        const response = await this.fxIdWebFeaturesGamesListEndpointRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesGamesListWithConfigsEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/games/list_with_configs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesGamesListWithConfigsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesGamesListWithConfigsEndpoint(initOverrides) {
        const response = await this.fxIdWebFeaturesGamesListWithConfigsEndpointRaw(initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=GamesApi.js.map